const Testimonials = () => {
  const testimonials = [
    {
      name: "Margaret, 48",
      image: "/placeholder.svg?height=100&width=100",
      quote:
        "I never thought I'd find love again at my age, but Aura proved me wrong. I met my partner here and we couldn't be happier!",
    },
    {
      name: "Robert, 62",
      image: "/placeholder.svg?height=100&width=100",
      quote:
        "The community here is wonderful. I've made so many new friends and even found a travel companion for my upcoming cruise.",
    },
  ];

  return (
    <section
      id="testimonials"
      className="py-20 px-4 md:px-6 lg:px-8 bg-gray-100"
    >
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          What Our Members Say
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                {/* <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  width={60}
                  height={60}
                  className="rounded-full mr-4"
                /> */}
                <h3 className="text-xl font-semibold">{testimonial.name}</h3>
              </div>
              <p className="text-gray-600 italic">"{testimonial.quote}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
